const breadcrumb = {
  extensions: 'Extensions',
  backups: 'Backups',
  configuration: 'Configuration'
}

export default breadcrumb
